import styled from 'styled-components'

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;

  .search-bar {
    margin: 16px 0px 8px;
  }
`

export const ListContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;

  overflow: scroll;
`
